export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/

export const MILLIS = {
  SECOND: 1000,
  MINUTE: 60000,
  HOUR: 3600000,
  DAY: 86400000,
  WEEK: 604800000,
  MONTH: 2629800000,
  YEAR: 31557600000,
} as const

// HRL-16: sanity cap on a single hourly-ticket time adjustment. Larger swings
// are split into several rows or escalated. Enforced by the backend, mirrored
// on the admin time form.
export const MAX_TIME_ADJUSTMENT_SECONDS = 12 * 3600
